import { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

import 'remixicon/fonts/remixicon.css';
import './shared/styles/main.scss';
import './shared/styles/utils/simplebar.css';
import { config } from '@services/context';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
const isCollectingTelemetry = config.isCollectingTelemetry || config.isDev;

root.render(
  <StrictMode>
    <App />
  </StrictMode>
);

serviceWorkerRegistration.register();
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals(isCollectingTelemetry ? console.log : undefined);
